import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Operario/addOperario`, method: 'POST', body: values, token: token})
}
